import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Clock, Sparkles } from "lucide-react";
import { productService } from "../services/productService";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const TodayOffers = ({ limit = 6 }) => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const response = await productService.getAllProducts();
        const products = response.data.filter((p) => p.discountPercentage > 0 || p.featured).slice(0, limit);
        setOffers(products);
      } catch (error) {
        console.error("Failed to fetch offers:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchOffers();
  }, [limit]);

  const getEndingTime = (index) => `${23 - (index % 12) * 2}h ${59 - (index % 4) * 15}m`;
  const getStockLeft = (index, discount) => Math.max(12, 100 - discount * 2 - index * 5);

  if (loading) {
    return (
      <div className="bg-white border border-sky-100 rounded-xl p-1.5 animate-pulse w-full">
        <div className="grid grid-cols-3 gap-1">
          {[1, 2, 3].map((n) => <div key={n} className="h-36 bg-sky-50 rounded-lg"></div>)}
        </div>
      </div>
    );
  }

  if (offers.length === 0) return null;

  return (
    <div className="relative bg-white border border-sky-100 rounded-xl p-1.5 shadow-sm overflow-hidden w-full">
      <div className="absolute top-0 left-0 right-0 h-[2px] bg-sky-400" />
      <div className="px-0.5 pb-1 flex items-center justify-between border-b border-sky-50 mb-1.5">
        <div className="flex items-center gap-1">
          <Sparkles className="text-sky-600" size={11} />
          <h3 className="text-slate-800 font-extrabold text-[10px] sm:text-[11px] tracking-wide uppercase">Limited OFFER</h3>
        </div>
       {/*} <Link to="/store?sort=priceLow" className="text-[9px] font-bold text-sky-600 hover:text-sky-800 transition-colors">View All</Link>*/}
      </div>
      <div className="w-full overflow-hidden">
        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          loop={offers.length > 3}
          spaceBetween={5}
          slidesPerView={3}
          breakpoints={{
            480: { slidesPerView: 4, spaceBetween: 6 },
            768: { slidesPerView: 5, spaceBetween: 6 },
            1024: { slidesPerView: 6, spaceBetween: 8 },
          }}
          className="w-full"
        >
          {offers.map((product, index) => {
            const discount = product.discountPercentage || Math.floor(Math.random() * 20) + 10;
            const originalPrice = product.price + (product.price * discount) / 100;
            const stockLeft = getStockLeft(index, discount);
            return (
              <SwiperSlide key={product._id} className="min-w-0 !h-auto">
                <Link to={`/product/${product._id}`} className="group flex flex-col justify-between bg-white border border-sky-100 hover:border-sky-300 rounded-lg overflow-hidden transition-all duration-300 shadow-sm min-w-0 h-full">
                  <div className="relative w-full h-[68px] bg-slate-50 flex items-center justify-center p-1 shrink-0 overflow-hidden">
                    <img src={product?.images?.[0]?.url || product.image} alt={product.name} className="h-full w-full object-contain mix-blend-multiply transition-transform duration-300 group-hover:scale-105" loading="lazy" />
                    <span className="absolute top-0.5 right-0.5 z-10 bg-sky-600 text-white font-black text-[7.5px] px-1 py-0.2 rounded shadow-xs tracking-tighter">-{discount}%</span>
                  </div>
                  <div className="p-1 flex-1 flex flex-col justify-between min-w-0 bg-white">
                    <div className="min-w-0 mb-1">
                      <h4 className="text-[8.5px] font-bold text-slate-800 line-clamp-2 leading-tight tracking-wide min-w-0 break-words transition-colors">{product.name}</h4>
                      <div className="w-full mt-0.5">
                        <div className="w-full bg-slate-100 h-[3px] rounded-full overflow-hidden">
                          <div className={`h-full rounded-full transition-all duration-500 ${stockLeft < 30 ? 'bg-amber-500' : 'bg-sky-500'}`} style={{ width: `${stockLeft}%` }} />
                        </div>
                      </div>
                    </div>
                    <div className="pt-1 border-t border-slate-50 flex items-center justify-between gap-1 w-full min-w-0 shrink-0">
                      <div className="flex items-baseline gap-1 shrink-0">
                        <span className="text-[9.5px] font-black text-slate-950">₹{product.price.toLocaleString("en-IN")}</span>
                        <span className="text-[8.5px] font-bold text-slate-900 line-through tracking-tighter opacity-60">₹{originalPrice.toFixed(0)}</span>
                      </div>
                      <div className="flex items-center gap-0.5 text-slate-900 font-bold shrink-0">
                        <Clock size={8} className="text-sky-600 shrink-0" />
                        <span className="font-mono text-[8.5px] tracking-tighter">{getEndingTime(index)}</span>
                      </div>
                    </div>
                  </div>
                </Link>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
};

export default TodayOffers;